import { internalEnvironment } from './environment.internal';
import { localEnvironment } from './environment.local';
import { IEnvironmentModel } from './environment.model';
import { productionEnvironment } from './environment.production';
import { stagingEnvironment } from './environment.staging';

export const environment = getEnvironment();

function getEnvironment(): IEnvironmentModel {
  const domain = window.location.hostname;
  switch (domain) {
    case productionEnvironment.domain:
      return productionEnvironment;
    case stagingEnvironment.domain:
      return stagingEnvironment;
    case `dev.${stagingEnvironment.domain}`:
      return {
        ...stagingEnvironment,
        dev: true,
        loginRedirectUrl: stagingEnvironment.loginRedirectUrl.replace(
          stagingEnvironment.domain,
          `dev.${stagingEnvironment.domain}`,
        ),
        oauth: {
          ...stagingEnvironment.oauth,
          issuer: undefined,
        },
      };
    case internalEnvironment.domain:
      return internalEnvironment;
    case localEnvironment.domain:
      return localEnvironment;
    default:
      console.error(`Unknown domain '${domain}', cannot determine environment`);
      throw new Error(`Unknown domain '${domain}', cannot determine environment`);
  }
}
